import React from 'react'

import {Slider, Item} from './Slider.styled'

const SliderComponent = (props) => {
  const {images} = props

  return (
    <>
      <Slider
        dots={false}
        infinite
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        nextArrow={<Item.Arrow next />}
        prevArrow={<Item.Arrow prev />}
      >
        {images.map(({id, url}) => (
          <Item
            key={id}
          >
            <div className='img-container'>
              <img
                alt='slider'
                src={url}
                className='img-contain-center'
              />
            </div>
          </Item>
        ))}
      </Slider>
    </>
  )
}

SliderComponent.defaultProps = {
  images: [],
}

export default SliderComponent
